export enum DeliveryMethod {
    CompanyTruck = 0,
    Container = 1
}

export const DeliveryMethodMetadata = {
    '0': {
        display: 'Company Truck',
        value: 0
    },
    '1': {
        display: 'Container',
        value: 1
    }
}